// comment
import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import MfaProtectedRoute from "@/components/MfaProtectedRoute";
import InactivityHandler from "@/components/InactivityHandler";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Settings from "./pages/Settings";
import OrganisationProfile from "./pages/OrganisationProfile";
import Confirmation from "./pages/Confirmation";
import NotFound from "./pages/NotFound";
import SetupMfa from "./pages/SetupMfa";
import VerifyMfa from "./pages/VerifyMfa";
import ResetMfa from "./pages/ResetMfa";
import AuthCallback from "./pages/AuthCallback";
import QuickBooksCallback from "./pages/QuickBooksCallback";
import LenderDashboard from "./pages/LenderDashboard";
import ResellerAuthCallback from "./pages/ResellerAuthCallback";
import ResellerPortal from "./pages/ResellerPortal";
import ViewPurchaseOrder from "./pages/ViewPurchaseOrder";
import StagingMigration from './pages/StagingMigration';

const queryClient = new QueryClient();

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthProvider>
            <InactivityHandler />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/step/:step" element={<Index />} />
              <Route path="/confirmation" element={<Confirmation />} />
              <Route path="/login" element={<Login />} />
              <Route path="/setup-mfa" element={<SetupMfa />} />
              <Route path="/verify-mfa" element={<VerifyMfa />} />
              <Route path="/reset-mfa" element={<ResetMfa />} />
              <Route path="/auth-callback" element={<AuthCallback />} />
              <Route path="/quickbooks-callback" element={<QuickBooksCallback />} />
              <Route path="/lender-dashboard" element={<LenderDashboard />} />
              
              {/* Reseller Portal Routes */}
              <Route path="/reseller/auth-callback" element={<ResellerAuthCallback />} />
              <Route path="/client/portal" element={<ResellerPortal />} />
              <Route path="/view-po" element={<ViewPurchaseOrder />} />
              
              <Route
                path="/admin" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <MfaProtectedRoute requireMfa={true}>
                      <Admin />
                    </MfaProtectedRoute>
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/admin/migrate"
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <MfaProtectedRoute requireMfa={true}>
                      <StagingMigration />
                    </MfaProtectedRoute>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings" 
                element={
                  <ProtectedRoute>
                    <MfaProtectedRoute>
                      <Settings />
                    </MfaProtectedRoute>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/organisation/:id" 
                element={
                  <MfaProtectedRoute requireMfa={true}>
                    <OrganisationProfile />
                  </MfaProtectedRoute>
                } 
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
